export function translateColumns(columns) {
  if (!columns.isTranslated) {
    columns.forEach(column => {
      if (column.headerName) {
        const translatePrefix = 'tables.';
        if (column.headerName.includes(translatePrefix)) {
          column.headerName = this.$i18n.t(column.headerName);
        } else {
          column.headerName = this.$i18n.t(`${translatePrefix}${column.headerName}`);
        }
        if (column.children && column.children.length) {
          column.children.forEach(subColumn => {
            if (subColumn.headerName) {
              if (subColumn.headerName.includes(translatePrefix)) {
                subColumn.headerName = this.$i18n.t(subColumn.headerName);
              } else {
                subColumn.headerName = this.$i18n.t(`${translatePrefix}${subColumn.headerName}`);
              }
            }

          });
        }
      }
    });
    columns.isTranslated = true;
  }
}


// WEBPACK FOOTER //
// ./src/helpers/translate-helper.js